<template>
  <div class="container row rounded-3 bg-secondary mb-5 py-3 px-5">
    <div class="col-12 col-md-6">
      <form >
        <div class="mb-3">
          <label for="locationCount" class="form-label">How many locations will you query data for?</label>
          <div class="row">
            <div class="col-6 col-md-4">
            <input type="number" class="form-control" id="locationCount" min="1"  v-model.number="locationCount" >
            </div>
          </div>
          <div  class="invalid-feedback" :class="{'d-block': errors.locationCount}" >
          {{errors.locationCount}}
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label ">What type of data will you be downloading?</label >
        
          <div v-for="(u,i) in availableDataTypes" class="form-check">
            <input class="form-check-input" type="radio" :id="u.id" v-model="dataType" :value="u"  >
            <label class="form-check-label" :for="u.id"  :value="u">
              {{u.label}}
            </label>
          </div>
        
        </div>

        <div class="mb-3">
          <label class="form-label">What time interval?</label >

          
          <div v-for="(u,i) in availableDataTimeIntervals" class="d-flex flex-columns align-items-center">
            <div class="form-check">
              <input class="form-check-input" type="radio" :id="u.id" v-model="dataTimeInterval" :value="u"  >
              <label class="form-check-label" :for="u.id"  :value="u">
                {{u.label}}
              </label>
            </div>
            <div v-if="u.id==='minutes'">
              <select class="form-select" v-model="minuteInterval"  :disabled="!isMinutes">
                <option v-for="(u,i) in availableMinuteIntervals" :value="u">{{u}}</option>
              </select>
            
            </div>
          </div>
          
        </div>

        <div class="mb-3 was-validated ">
          <label class="form-label">What length of time range?</label >
          <div class="row ">
            <div class="col-6 col-md-4">
              <input type="number" class="form-control cols-1"   id="timeRangeCount" min="1"  v-model.number="timeRangeCount">
            </div>
            <div class="col-6 col-md-4">
              <select class="form-select" v-model="timeRange">
                <option v-for="(u,i) in availableTimeRanges" :value="u">{{u.label}}</option>
              </select>
            </div>
          </div>
          <div  class="invalid-feedback" :class="{'d-block': errors.timeRangeCount}" >
          {{errors.timeRangeCount}}
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label">Will you refresh the data regularly?</label>
          <div v-for="(u,i) in availableRefreshDataCounts" class="form-check">
              <input class="form-check-input" type="radio" :id="u.id" v-model="refreshDataCount" :value="u"  >
              <label class="form-check-label" :for="u.id"  :value="u">
                {{u.label}}
              </label>
            </div>
        </div>
      </form>
    </div>
    <div v-if="!hasError" class="col-12 col-md-6 text-center d-flex flex-column flex-row align-items-center justify-content-center">
          <div class="h4">Recommended plan</div>
          <div class="h3">{{recommendedPlan}}</div>
          <div class="fs-4">Estimated metered costs: {{estimatedDollarCostsLabel}}</div>
          <div class="fs-4">{{estimatedDatasetCosts}} query cost per location dataset</div>
          <div class="fs-4">{{estimatedMonthlyCosts}} query cost per month</div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'costcalculator',
  props: {
    
  },
  emits: [],
  data() {
    return {
      availableDataTypes: [
        {
          id:"hist",
          label:"Historical",
        },
        {
          id:"fcst",
          label:"Forecast",
        },
        {
          id:"histfcst",
          label:"Historical Forecast",
        },
        
      ],
      availableDataTimeIntervals: [
        {
          id:"days",
          label:"Daily",
        },
        {
          id:"hours",
          label:"Hourly",
        },
        {
          id:"minutes",
          label:"Minutely",
        }
      ],
      availableMinuteIntervals: [5,10,15,20,30],
      availableTimeRanges: [
        {
          id:"hours",
          label:"Hours",
        },
        {
          id:"days",
          label:"Days",
        },
        {
          id:"months",
          label:"Months",
        },
        {
          id:"years",
          label:"Years",
        },
      ],
      availableRefreshDataCounts: [
        {
          id:1,
          label:"Once",
        },
        {
          id:7,
          label:"Every week",
        },
        {
          id:31,
          label:"Every day",
        }
      ],
     
      locationCount:1,
      timeRangeCount:1,
      minuteInterval:15,
      dataType:null,
      timeRange:null,
      dataTimeInterval:null,
      refreshDataCount:null,
    }
  },
  methods:{
    
  },
  computed:{
    errors(){
      let me=this;
      return {
        timeRangeCount:me.timeRangeCount<1?"Invalid time range count":null,
        locationCount:me.locationCount<1?"Invalid location count":null
      }
    },
    hasError() {
      let me=this;
      return me.errors && (me.errors.timeRangeCount || me.errors.locationCount)
    },
    isMinutes() {
      let me=this;
      return me.dataTimeInterval && me.dataTimeInterval.id==="minutes";
    },
    isFcst() {
      let me=this;
      return me.dataType && me.dataType.id==="fcst";
    },
    isHist() {
      let me=this;
      return me.dataType && me.dataType.id==="hist";
    },
    isHistFcst() {
      let me=this;
      return me.dataType && me.dataType.id==="histfcst";
    },
    recommendedPlan() {
      let me=this;
      if (me.estimatedMonthlyCosts>500000000) {
        return "Entrprise Plan";
      } else if (me.estimatedDollarCosts>150) {
        return "Corporate Plan";
      } else if (me.estimatedDollarCosts>35) {
        return "Pro Plan";
      } else {
        return "Metered";
      }
    },
    estimatedDollarCosts() {
      let me=this;
      return me.estimatedMonthlyCosts*0.0001;
    },
    
    estimatedDollarCostsLabel() {
      let me=this;
      if (me.estimatedDollarCosts<0.01) {
        return "<$0.01";
      }
      return `$${me.estimatedDollarCosts.toFixed(2)}`;
    },
    estimatedDatasetCosts() {
      let me=this;
      if (me.isFcst) return 1;
      let hours=0;
      if (!me.timeRange || !me.dataTimeInterval) return 0;
      switch (me.timeRange.id) {
        case "hours":
          hours=me.timeRangeCount;
          break;
        case "days":
          hours=me.timeRangeCount*24;
          break;
        case "months":
          hours=me.timeRangeCount*24*31;
          break;
        case "years":
          hours=me.timeRangeCount*24*365;
          break;

      }
      let days=Math.ceil(hours/24);
      
      switch (me.dataTimeInterval.id) {
        case "days":
          return days;
        case "hours":
          return hours;
        case "minutes":
          return hours*(60/me.minuteInterval);
      }

      return 0;
    },
    estimatedMonthlyCosts() {
      let me=this;
      if (!me.refreshDataCount) return "-";
      return me.estimatedDatasetCosts*me.locationCount*me.refreshDataCount.id;
    },
  },
  watch: {
   
  },
  mounted() {
    let me=this;
    me.locationCount=1;
    me.dataType=me.availableDataTypes[0];
    me.timeRangeCount=7;
    me.timeRange=me.availableTimeRanges[1];
    me.dataTimeInterval=me.availableDataTimeIntervals[0];
    me.refreshDataCount=me.availableRefreshDataCounts[0];
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>